<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" ref="form" label-width="130px" v-loading="loading">
        <el-row>
          <el-col :span="12">
            <el-form-item prop="pointName" label="点位名称">
              {{ formData.pointName || '' }}

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="location" label="所在位置">
              {{ formData.location || '' }}
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :span="24">
          <el-form-item prop="itemLis" label="检查项">
            <!-- <div v-for="(item, index) of formData.itemLis" class="text-row" :key="index">
              {{ item || '' }}
            </div> -->
            <el-table size="mini" stripe border :data="formData.itemLis">
              <el-table-column show-overflow-tooltip min-width="100" label="检查项" prop="">
                <template v-slot="{row}">
                  {{ row||'' }}
                </template>
              </el-table-column>

            </el-table>
          </el-form-item>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </custom-actions>

  </div>
</template>

<script>
export default {
  name: 'inspectionPoint',

  data () {
    return {
      formData: {
        pointName: '',
        pointType: '',
        location: '',
        itemLis: []
      },

      loading: false

    }
  },
  created () {
    if (this.pointId) {
      this.loadData()
    }
  },
  computed: {
    pointId () {
      return this.$route.query.pointId
    },
    pointType () {
      return this.$route.query.pointType
    }
  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.inspectionPoint.selectPaInspectPointByPointId, {
          params: { pointId: this.pointId }
        })
        .then(res => {
          res.itemLis = res.itemLis ? res.itemLis : []
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    }

  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}

.text-row {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  flex-wrap: wrap;
  word-break: break-all;
  line-height: 24px;
  position: relative;
  padding-left: 10px;

  &:before {
    content: '';
    width: 3px;
    height: 14px;
    background-color: #3458f9;
    border-radius: 2px;
    position: absolute;
    left: 0;
    top: 6px;
  }

}
</style>
